import { Map } from 'immutable';

import { REWARD__GET_IMMIDIATE } from '../constants';
import { patch } from '../../util';

const defaultState = new Map();

export default function (state = defaultState, action) {
  switch (action.type) {
    case REWARD__GET_IMMIDIATE:
      return patch(state, action.data);
    default:
      return state;
  }
}
